import { c as _c } from "react/compiler-runtime";
import React from "react";
import Tabs, { type TabItem } from "@/components/terra/component/Tabs/Tabs";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createRichTextOptions } from "@/lib/formatters/formatRichText";
import { resolveContentfulRichTextLinks } from "@/lib/formatters/formatLinks";
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale";
export default function MXPEmbeddedRichTextTabs(props) {
  const $ = _c(9);
  const {
    value,
    lang: t0
  } = props;
  const lang = t0 === undefined ? DEFAULT_PUBLIC_LANG : t0;
  let t1;
  if ($[0] !== lang || $[1] !== value.tabsCollection?.items) {
    let t2;
    if ($[3] !== lang) {
      t2 = tab_0 => {
        const resolvedBody = resolveContentfulRichTextLinks(tab_0.body);
        return {
          header: tab_0.displayTitle || "",
          content: resolvedBody?.json ? <div className="richtxt">{documentToReactComponents(resolvedBody.json, createRichTextOptions(lang))}</div> : null,
          contentfulId: tab_0.sys?.id || undefined
        };
      };
      $[3] = lang;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = (value.tabsCollection?.items ?? []).filter(_temp).map(t2);
    $[0] = lang;
    $[1] = value.tabsCollection?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tabItems = t1;
  const orientation = value.tabPositioning === "left" ? "left" : "top";
  const t2 = value.sys?.id || undefined;
  let t3;
  if ($[5] !== orientation || $[6] !== t2 || $[7] !== tabItems) {
    t3 = <Tabs tabs={tabItems} orientation={orientation} variant="text-background-light" displayThumbnails={false} contentfulId={t2} />;
    $[5] = orientation;
    $[6] = t2;
    $[7] = tabItems;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(tab) {
  return tab != null;
}